import { BaseNode } from "./BaseNode";
import { OnDemandArt57NodeList } from "./MedicinalProductsNode/ListEntity/OnDemandArt57NodeList";
import { OnDemandAutoUploadList } from "./MedicinalProductsNode/ListEntity/OnDemandAutouploadList";
import { OnDemandAutoUploadNode } from "./MedicinalProductsNode/OnDemandAutoUploadNode";

export class OnDemandNode extends BaseNode { 

    getOnDemandEntity():any{
      let entitiesArray: any[] = [];
      this.children?.forEach((child: any) => {
            let onDemandEntity:any;
            if (child instanceof OnDemandNode) {
              onDemandEntity = child.getOnDemandEntity();
            } else if (child instanceof OnDemandAutoUploadNode) {
              onDemandEntity = child.getOnDemandEntities();
            }

            if ((onDemandEntity) && (Array.isArray(onDemandEntity) || Object.keys(onDemandEntity ).length !== 0)) {
              entitiesArray.push(onDemandEntity);
            }
      });
      
      if (entitiesArray.length>0) {
        return {...this.data.model,entitiesArray};
      } else {
        return {...this.data.model};
      }     
    }
}